<template>
    <tr>
        <td>
            <button v-if="checkIfEditEnabled && !exportDocsDisabled" class="button is-primary" @click="updateItem" :disabled="isLocked">
                <i class="fas fa-save"></i>
            </button>
            <button  v-if="!checkIfEditEnabled && !exportDocsDisabled" class="button" @click="editItem" :disabled="isLocked">
                <i class="fas fa-edit"></i>
            </button>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled" v-html="item.name "></span>
            <input class="input" v-if="checkIfEditEnabled" v-model="name" :disabled="isLocked"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.remarks }}</span>
            <input class="input" v-if="checkIfEditEnabled" v-model="remarks" :disabled="isLocked"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.amount }}</span>
            <input class="input" v-if="checkIfEditEnabled" v-model="amount" :disabled="isLocked || exportDocsDisabled"/>
        </td>
        <td>
            <button class="button is-danger" v-if="index > 0 && !exportDocsDisabled" @click="deleteItem" :disabled="isLocked">
                <i class="fas fa-trash"></i>
            </button>
        </td>
    </tr>
</template>

<script>
    export default {
        props:['item', 'index'],
        computed: {
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            },
            exportDocsDisabled() {
                return this.item.name == 'EXPORT DOCS' ? true : false
            },
            checkIfEditEnabled() {
                return this.$store.getters.getProformaInvoiceSelectedCostItem.id === this.item.id
            },
            name: {
                get() {
                   return this.$store.getters.getProformaInvoiceSelectedCostItem.name
                },
                set(value) {
                   this.$store.dispatch('changeProformaInvoiceSelectedCostItemFieldValue', { field: 'name', value: value})
                }
            },
            remarks: {
                get() {
                    return this.$store.getters.getProformaInvoiceSelectedCostItem.remarks
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceSelectedCostItemFieldValue', { field: 'remarks', value: value})
                }
            },
            amount: {
                get() {
                    return this.$store.getters.getProformaInvoiceSelectedCostItem.amount
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceSelectedCostItemFieldValue', { field: 'amount', value: value})
                }
            }
        },
        methods: {
            editItem() {
                this.$store.dispatch('changeProformaInvoiceSelectedCostItem', this.item)
                this.$store.dispatch('changeProformaInvoiceSelectedCostItemIndex', this.index)
            },
            updateItem() {
                this.$store.dispatch('updateProformaInvoiceCostItem')
                this.$store.dispatch('changeProformaInvoiceTotalCostAmount')
                this.$store.dispatch('calculateProformaInvoice')
            },
            deleteItem() {
                this.$store.dispatch('deleteProformaInvoiceCostItem', this.item)
                this.$store.dispatch('changeProformaInvoiceTotalCostAmount')
                this.$store.dispatch('calculateProformaInvoice')
            }
        },
        mounted() {
            this.$store.dispatch('calculateProformaInvoice')
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceCostsTableRow.vue